import Vue from 'vue';

import App from './App.vue';
import router from './router';
import './scss/app.scss'

import { store } from "./store-init";

require('./apiConfig');
require('./components/component-loader');
require('./staticContent');
require('./portfolioContent');
require('./filters');


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
